import ContinuePage from "@components/ContinuePage"

export default function HomeAlmostTherePage() {
  return <ContinuePage emoji="🏠" translationKey="homeAlmostThere" />
}
